import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TourDeskIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TourDeskIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.1265 5.6218C17.1265 4.34312 16.0862 3.30283 14.8075 3.30283C13.5288 3.30283 12.4885 4.34312 12.4885 5.6218C12.4885 6.90048 13.5288 7.94077 14.8075 7.94077C16.0862 7.94077 17.1265 6.90048 17.1265 5.6218ZM14.8075 6.78128C14.1682 6.78128 13.648 6.26114 13.648 5.6218C13.648 4.98246 14.1682 4.46232 14.8075 4.46232C15.4469 4.46232 15.967 4.98246 15.967 5.6218C15.967 6.26114 15.4469 6.78128 14.8075 6.78128Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M22.0717 6.31374C21.5951 5.583 20.6221 5.33815 19.8564 5.75634L15.8567 7.94081H8.44973V2.68448C8.44973 2.36431 8.19016 2.10474 7.86999 2.10474H3.13443C2.81426 2.10474 2.55469 2.36431 2.55469 2.68448V6.20158C2.55469 6.52175 2.81426 6.78132 3.13443 6.78132H7.29021V21.3135C7.29021 21.6337 7.54978 21.8932 7.86995 21.8932C8.19012 21.8932 8.44969 21.6337 8.44969 21.3135V11.4192H11.9281V20.154C11.9281 21.6613 13.7169 22.4439 14.8268 21.4493C15.9357 22.4429 17.7256 21.6636 17.7256 20.154V11.1537L21.5809 8.6421C22.3601 8.13448 22.5798 7.09288 22.0717 6.31374ZM3.71417 5.6218V3.26419H7.29021V5.6218H3.71417ZM15.9863 20.7337C15.6667 20.7337 15.4066 20.4736 15.4066 20.154V16.6369C15.4066 16.3167 15.147 16.0571 14.8268 16.0571C14.5067 16.0571 14.2471 16.3167 14.2471 16.6369V20.154C14.2471 20.4736 13.987 20.7337 13.6674 20.7337C13.3477 20.7337 13.0876 20.4736 13.0876 20.154V14.8977H16.5661V20.154C16.5661 20.4736 16.306 20.7337 15.9863 20.7337ZM20.948 7.67056L16.8293 10.3537C16.6651 10.4607 16.5661 10.6435 16.5661 10.8395V13.7382H13.0876V10.8395C13.0876 10.5193 12.828 10.2597 12.5079 10.2597H8.44969V9.10025C16.3446 9.0754 16.0419 9.16077 16.2826 9.02933L20.4121 6.77394C20.65 6.644 20.9524 6.72006 21.1005 6.94713C21.2583 7.18915 21.1902 7.51283 20.948 7.67056Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TourDeskIcon;
